export default [
  {
    path: "/profile",
    name: "profile",
    component: () => import("../views/Profile"),
  },
  {
    path: "/settings",
    name: "settings",
    component: () => import("../views/Settings"),
  },
  {
    path: "/account/login",
    name: "account.login",
    component: () => import("../views/account/Login"),
  },
  {
    path: "/account/register",
    name: "account.register",
    component: () => import("../views/account/Register"),
  },
  {
    path: "/account/password-reset",
    name: "account.passwordReset",
    component: () => import("../views/account/PasswordReset"),
  },
  {
    path: "/account/verify-email-address",
    name: "account.verifyEmailAddress",
    component: () => import("../views/account/VerifyEmailAddress"),
  },
  {
    path: "/membership",
    name: "membership",
    component: () => import("../views/Membership"),
  },
  {
    path: "/membership/extend",
    name: "membership.extend.default",
    component: () => import("../views/membership/Extend"),
    children: [
      {
        path: "",
        name: "membership.extend",
        component: () => import("../views/membership/extend/Index"),
      },
      {
        path: "30",
        name: "membership.extend.30",
        component: () => import("../views/membership/extend/30"),
      },
      {
        path: "360",
        name: "membership.extend.360",
        component: () => import("../views/membership/extend/360"),
      },
    ],
  },
  {
    path: "/email-action",
    name: "emailAction",
    component: () => import("../views/EmailAction"),
  },
  {
    path: "/admin",
    name: "admin",
    component: () => import("../views/AdminArea"),
  },
  {
    path: "/licenses",
    name: "licenses",
    component: () => import("../views/Licenses"),
  },
  {
    path: "/:catchALL(.*)",
    name: "notFound",
  },
];
